module.exports = __webpack_public_path__ + "img/recovery-password.6b9c079d.png";